import { BusRoute, BusRouteDataMap } from './route-types';

export const busRoutes = [
  // {
  //   route: 'Green Route',
  //   id: '7002',
  // },
  // {
  //   route: 'Orange Route',
  //   id: '7003',
  // },
  // {
  //   route: 'Red Route',
  //   id: '7001',
  // },
  {
    route: 'Route 191',
    id: '191',
  },
];

const greenRoute: BusRoute = {
  routeName: 'Green Route',
  stops: [
    {
      direction: 1,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'GS1',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'GS2',
          index: 131,
        },
        {
          stopSequence: '3',
          stopCode: 'GS3',
          index: 360,
        },
        {
          stopSequence: '4',
          stopCode: 'GS4',
          index: 509,
        },
        {
          stopSequence: '5',
          stopCode: 'GS5',
          index: 881,
        },
        {
          stopSequence: '6',
          stopCode: 'GS6',
          index: 995,
        },
        {
          stopSequence: '7',
          stopCode: 'GS7',
          index: 1238,
        },
        {
          stopSequence: '8',
          stopCode: 'GS8',
          index: 1430,
        },
        {
          stopSequence: '9',
          stopCode: 'GS9',
          index: 1794,
        },
        {
          stopSequence: '10',
          stopCode: 'GS10',
          index: 2187,
        },
      ],
    },
    {
      direction: 2,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'GS10',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'GS9',
          index: 392,
        },
        {
          stopSequence: '3',
          stopCode: 'GS8',
          index: 757,
        },
        {
          stopSequence: '4',
          stopCode: 'GS7',
          index: 948,
        },
        {
          stopSequence: '5',
          stopCode: 'GS6',
          index: 1192,
        },
        {
          stopSequence: '6',
          stopCode: 'GS5',
          index: 1306,
        },
        {
          stopSequence: '7',
          stopCode: 'GS4',
          index: 1677,
        },
        {
          stopSequence: '8',
          stopCode: 'GS3',
          index: 1826,
        },
        {
          stopSequence: '9',
          stopCode: 'GS2',
          index: 2054,
        },
        {
          stopSequence: '10',
          stopCode: 'GS1',
          index: 2187,
        },
      ],
    },
  ],
  color: '#038803',
  colorAlt: '#086608',
  colorAlt2: '#064A06',
  busCode: 'G',
  busCount: 6,
  busId: 7002,
  timeStop: 5,
  busIdStr: '7002',
  busArr: ['SG6042C', 'SG1713H', 'SG5031R', 'SG1894T', 'SG5115H', 'SG6184B'],
  timeslotPeriodMinutes: 15,
  isFixed: false,
};

const redRoute: BusRoute = {
  routeName: 'Red Route',
  stops: [
    {
      direction: 1,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'RS1',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'RS2',
          index: 125,
        },
        {
          stopSequence: '3',
          stopCode: 'RS3',
          index: 250,
        },
        {
          stopSequence: '4',
          stopCode: 'RS4',
          index: 434,
        },
        {
          stopSequence: '5',
          stopCode: 'RS5',
          index: 609,
        },
        {
          stopSequence: '6',
          stopCode: 'RS6',
          index: 742,
        },
        {
          stopSequence: '7',
          stopCode: 'RS7',
          index: 1098,
        },
      ],
    },
    {
      direction: 2,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'RS7',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'RS6',
          index: 356,
        },
        {
          stopSequence: '3',
          stopCode: 'RS5',
          index: 490,
        },
        {
          stopSequence: '4',
          stopCode: 'RS4',
          index: 665,
        },
        {
          stopSequence: '5',
          stopCode: 'RS3',
          index: 848,
        },
        {
          stopSequence: '6',
          stopCode: 'RS2',
          index: 973,
        },
        {
          stopSequence: '7',
          stopCode: 'RS1',
          index: 1098,
        },
      ],
    },
  ],
  color: '#f03030',
  colorAlt: '#991010',
  colorAlt2: '#600808',
  busCode: 'R',
  busCount: 3,
  busId: 7001,
  busIdStr: '7001',
  timeStop: 5,
  busArr: ['SG1791G', 'SG6186X', 'SG5143B'],
  timeslotPeriodMinutes: 15,
};

const orangeRoute: BusRoute = {
  routeName: 'Orange Route',
  stops: [
    {
      direction: 1,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'OS1',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'OS2',
          index: 255,
        },
        {
          stopSequence: '3',
          stopCode: 'OS3',
          index: 712,
        },
        {
          stopSequence: '4',
          stopCode: 'OS4',
          index: 884,
        },
        {
          stopSequence: '5',
          stopCode: 'OS5',
          index: 1156,
        },
      ],
    },
    {
      direction: 2,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'OS5',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'OS4',
          index: 272,
        },
        {
          stopSequence: '3',
          stopCode: 'OS3',
          index: 444,
        },
        {
          stopSequence: '4',
          stopCode: 'OS2',
          index: 900,
        },
        {
          stopSequence: '5',
          stopCode: 'OS1',
          index: 1156,
        },
      ],
    },
  ],
  color: '#FFA500',
  colorAlt: '#F08000',
  colorAlt2: '#FF7518',
  busCode: 'O',
  busCount: 5,
  busId: 7003,
  busIdStr: '7003',
  timeStop: 5,
  busArr: ['SG1769Y', 'SG1778X', 'SG1784C', 'SG1759B', 'SG1768A'],
  timeslotPeriodMinutes: 15,
};

const route191: BusRoute = {
  routeName: 'Route 191',
  stops: [
    {
      direction: 1,
      stop: [
        // {
        //   stopSequence: '1',
        //   stopCode: '11379',
        //   index: 0,
        // },
        {
          stopSequence: '1',
          stopCode: '11381',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: '11181',
          index: 28,
        },
        {
          stopSequence: '3',
          stopCode: '11369',
          index: 46,
        },
        {
          stopSequence: '4',
          stopCode: '18149',
          index: 70,
        },
        {
          stopSequence: '5',
          stopCode: '18151',
          index: 99,
        },
        {
          stopSequence: '6',
          stopCode: '18171',
          index: 145,
        },
        {
          stopSequence: '7',
          stopCode: '18181',
          index: 157,
        },
        {
          stopSequence: '8',
          stopCode: '18191',
          index: 184,
        },
        {
          stopSequence: '9',
          stopCode: '18211',
          index: 205,
        },
        {
          stopSequence: '10',
          stopCode: '18201',
          index: 238,
        },
        {
          stopSequence: '11',
          stopCode: '18199',
          index: 269,
        },
        {
          stopSequence: '12',
          stopCode: '18189',
          index: 291,
        },
        {
          stopSequence: '13',
          stopCode: '18179',
          index: 308,
        },
        {
          stopSequence: '14',
          stopCode: '18159',
          index: 342,
        },
        {
          stopSequence: '15',
          stopCode: '18141',
          index: 379,
        },
        {
          stopSequence: '16',
          stopCode: '11361',
          index: 397,
        },
        {
          stopSequence: '17',
          stopCode: '11189',
          index: 423,
        },
        {
          stopSequence: '18',
          stopCode: '11389',
          index: 445,
        },
        // {
        //   stopSequence: '20',
        //   stopCode: '11379',
        //   index: 469,
        // },
      ],
    },
  ],
  // color: '#FFA500',
  // colorAlt: '#F08000',
  // colorAlt2: '#FF7518',
  busCode: '191',
  busCount: 3,
  busId: 191,
  busIdStr: '191',
  timeStop: 5,
  busArr: ['AV01', 'AV02', 'AV03'],
  timeslotPeriodMinutes: 15,
  isFixed: true,
};

export const routeData: BusRouteDataMap = {
  // '7001': redRoute,
  // '7002': greenRoute,
  // '7003': orangeRoute,
  '191': route191,
};
